angular.module('gym.components').directive('contactSubscription', function() {
  return {
    restrict: 'E',
    scope: {
      contact: '=',
      reloadContact: '&',
      updateChannel: '&'
    },
    template: require('templates/components/contacts/comms/contact_subscription.html.slim'),
    controller: ["$scope", function($scope) {
      var reload;
      $scope.reactivateEmail = function() {
        return $scope.contact.customPUT({}, 'reactivate_email').then(function(data) {
          return reload();
        });
      };
      $scope.reactivateSms = function() {
        return $scope.contact.customPUT({}, 'reactivate_sms').then(function(data) {
          return reload();
        });
      };
      return reload = function() {
        return $scope.reloadContact().then(function() {
          return $scope.updateChannel();
        });
      };
    }]
  };
});
